module.exports = __webpack_public_path__ + "img/aparecida.1fc87396.png";